import DataItems from '../adresses/settings/DataItems';
import Locations from '../adresses/settings/Locations';
import PrivacyPolicy from '../adresses/settings/PrivacyPolicy';
import ThankYouText from '../adresses/settings/ThankYouText';
import AdjustStatusInTaskEditor from '../adresses/settings/AdjustStatusInTaskEditor';
import AutoPlanHouseVisitStatus from '../adresses/settings/AutoPlanHouseVisitStatus';
import AutoCompleteHouseVisitStatus from '../adresses/settings/AutoCompleteHouseVisitStatus';
import AllowNegativeStock from '../adresses/settings/AllowNegativeStock';
import WervingsactiesMenuToggle from '../adresses/settings/WervingsactiesMenuToggle';
import WervingsDienstenConfig from '../adresses/settings/WervingsDienstenConfig';
import DefaultHouseVisitReminderToggle from '../adresses/settings/DefaultHouseVisitReminderToggle';
import SmsRemindersToggle from '../adresses/settings/SmsRemindersToggle';
import DefaultAgendaView from '../adresses/settings/DefaultAgendaView';
import AgendaSettings from '../adresses/settings/AgendaSettings';
import UnreachableAfterDays from '../adresses/settings/UnreachableAfterDays';
import Roles from '../adresses/settings/Roles';
import StatusConfigTable from './StatusConfigTable';
import SettingsGroup from './SettingsGroup';
import HouseholdColumnsConfig from '../adresses/settings/HouseholdColumnsConfig';
import AdressLabelsConfig from '../adresses/settings/AdressLabelsConfig';
import AppointmentKindsConfig from '../adresses/settings/AppointmentKindsConfig';
import HourlyRatesConfig from '../adresses/settings/HourlyRatesConfig';
import StickyDeleteColumn from '../adresses/settings/StickyDeleteColumn';
import { ADRESS_STATUS_LABELS } from '../../helpers/adressHelpers/adressStatusLabels';
import { ADRESS_STATUS_DEFAULT_COLORS } from '../../helpers/statusConfig/resolveStatusColors';
// import StandardTasks from './StandardTasks';

const Adresses = ({selectedOption}) => {
  return (
    <>
        {selectedOption === '6' &&
            <div className="settings-container">
                <SettingsGroup id="settings-huishoudens" title="Huishoudens">
                    <StatusConfigTable
                        title="Statussen van huishoudens"
                        description="Geef een status je eigen naam, of haal een status die je niet gebruikt uit beeld."
                        canonicalLabels={ADRESS_STATUS_LABELS}
                        field="AdressStatusConfig"
                        colorDefaults={ADRESS_STATUS_DEFAULT_COLORS}
                    />
                    <HouseholdColumnsConfig />
                    <AdressLabelsConfig />
                    <StickyDeleteColumn />
                    <AdjustStatusInTaskEditor />
                    <AutoPlanHouseVisitStatus />
                    <AutoCompleteHouseVisitStatus />
                    <UnreachableAfterDays />
                    <WervingsactiesMenuToggle />
                    <WervingsDienstenConfig />
                    <AllowNegativeStock />
                </SettingsGroup>
                <SettingsGroup id="settings-agenda" title="Agenda en afspraken">
                    <DefaultAgendaView />
                    <AgendaSettings />
                    <AppointmentKindsConfig />
                    <HourlyRatesConfig />
                    <DefaultHouseVisitReminderToggle />
                    <SmsRemindersToggle />
                </SettingsGroup>
                <SettingsGroup id="settings-organisatie" title="Organisatie">
                    <Locations />
                    <PrivacyPolicy />
                    <ThankYouText />
                </SettingsGroup>
            </div>
        }
    </>
  )
}

export default Adresses
